import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/products/${product.slug}/`}
      data-testid={`product-card-${product.slug}`}
      className="group block border border-[#E2E3EE] bg-[#FFFFFF] hover:border-[#1A1B2E] transition-colors"
    >
      <div className="aspect-[4/5] overflow-hidden bg-[#F0F1F8]">
        <img
          src={product.images[0]}
          alt={product.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="p-6 flex items-start justify-between gap-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#282760]">
            {product.category.replace("-", " ")}
          </div>
          <div
            className="mt-2 text-2xl tracking-tight text-[#1A1B2E]"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
          >
            {product.name}
          </div>
          <div className="mt-1 text-sm text-[#5B5E78]">{product.tagline}</div>
        </div>
        <ArrowUpRight
          size={20}
          className="text-[#1A1B2E] mt-1 shrink-0 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
        />
      </div>
    </Link>
  );
};
